import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="loading-card">
        <div className="shimmer-header">
          <div className="shimmer shimmer-circle"></div>
          <div className="shimmer-text-group">
            <div className="shimmer shimmer-text-lg"></div>
            <div className="shimmer shimmer-text-sm"></div>
          </div>
        </div>
        <div className="shimmer-body">
          <div className="shimmer shimmer-price"></div>
          <div className="shimmer shimmer-text-md"></div>
          <div className="shimmer-stats">
            <div className="shimmer shimmer-stat"></div>
            <div className="shimmer shimmer-stat"></div>
            <div className="shimmer shimmer-stat"></div>
            <div className="shimmer shimmer-stat"></div>
          </div>
        </div>
      </div>
      <div className="loading-card">
        <div className="shimmer-body">
          <div className="shimmer shimmer-text-lg" style={{ width: '40%' }}></div>
          <div className="shimmer-karats">
            <div className="shimmer shimmer-karat"></div>
            <div className="shimmer shimmer-karat"></div>
            <div className="shimmer shimmer-karat"></div>
            <div className="shimmer shimmer-karat"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
